import { GROUNDED_QA_PLACEHOLDER_QUESTIONS } from './constants';
import { EAiCitationSourceType } from '../types';

export const pickRandomPlaceholderQuestion = (): string =>
  GROUNDED_QA_PLACEHOLDER_QUESTIONS[Math.floor(Math.random() * GROUNDED_QA_PLACEHOLDER_QUESTIONS.length)];

export const sourceTypeToPath = (sourceType: EAiCitationSourceType): string => {
  switch (sourceType) {
    case EAiCitationSourceType.DOCUMENT:
      return 'document';
    case EAiCitationSourceType.FILE:
      return 'file';
    case EAiCitationSourceType.LITERATURE:
      return 'literature';
  }
};
